import { PureComponent } from 'react'
import PropTypes from 'meta/PropTypes'
import { Box, Flex, Layout } from 'react-flex-lite'
import cn from 'classnames'
import { desktopWidth, largeDesktopWidth } from 'styles/sizes'
import './index.scss'

const getWidthStyle = (centeredWidth) => {
  const width = centeredWidth
    ? desktopWidth
    : largeDesktopWidth

  return {
    maxWidth: width,
    width: '100%',
    margin: '0 auto'
  }
}

@Layout
export class HeroHeader extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    centeredWidth: PropTypes.bool,
    style: PropTypes.object
  }
  static defaultProps = {
    style: {},
    centeredWidth: false
  }

  render = () => {
    const { centeredWidth, className, style, ...rest } = this.props
    return <Flex
      className={cn('hero-header-component', className)}
      style={{
        ...style,
        ...getWidthStyle(centeredWidth)
      }}
      {...rest}>
      {this.props.children}
    </Flex>
  }
}

@Layout
export class HeroContent extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    centeredWidth: PropTypes.bool,
    style: PropTypes.object
  }
  static defaultProps = {
    style: {},
    centeredWidth: false
  }

  render = () => {
    const { centeredWidth, className, style, ...rest } = this.props
    return <Flex
      className={cn('hero-content-component', className)}
      style={{
        ...style,
        ...getWidthStyle(centeredWidth)
      }}
      {...rest}>
      {this.props.children}
    </Flex>
  }
}

@Layout
export class Hero extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    fadedBackground: PropTypes.bool,
    backgroundImage: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string
  }

  static defaultProps = {
    style: {}
  }

  render = () => {
    const { style, backgroundImage, fadedBackground, className, ...rest } = this.props
    const bgStyle = backgroundImage && {
      backgroundImage: `url(${backgroundImage})`
    }
    return <Box className={cn('hero-component', className)} style={style} {...rest}>
      {bgStyle && <Box className={cn('hero-background-image', { faded: fadedBackground })} style={bgStyle} />}
      {this.props.children}
    </Box>
  }
}
